


































import { Component, Vue } from 'vue-property-decorator'
import ListItem from './ListItem.vue'
import EmptyPlaceholder from './EmptyPlaceholder.vue'
import { State, Action, Mutation } from 'vuex-class'
import { throttle } from 'throttle-debounce'
import { ORDER_MAP } from '@/utils/constants'

const offsetY = 50
@Component({
  name: 'Result',
  components: {
    ListItem,
    EmptyPlaceholder,
  },
})
export default class Result extends Vue {
  @State result: any
  @State resultLoading: any
  @State('order') stateOrder
  @Mutation('setOrder') mutationSetOrder
  @Action('getResult') actionGetResult
  page = 1 // 当前 page
  orderOpt = ORDER_MAP // 排序option

  get resultList() {
    const { list = [] } = this.result
    return list
  }

  handleSortByType(item) {
    const { order } = item
    // 点击同一个按钮，则不做处理
    if (order === this.stateOrder) {
      console.log('no')
      return false
    }
    // 如果接口正在请求，那么就不做操作
    if (this.resultLoading) {
      return false
    }
    // 设置当前 order 值
    console.log('order:', order)
    this.mutationSetOrder(order)
    this.actionGetResult({})
  }

  beforeDestroy() {
    window.removeEventListener('scroll', this.throttleScroll, true)
  }

  mounted() {
    // 监听滚动
    window.addEventListener('scroll', this.throttleScroll, true)
  }

  // 添加节流
  throttleScroll = throttle(300, this.handleScroll)

  // 滚动操作
  handleScroll() {
    this.$nextTick(() => {
      // 正在加载中
      if (this.resultLoading) {
        return false
      }
      //文档内容实际高度（包括超出视窗的溢出部分）
      const scrollHeight =
        document.documentElement.scrollHeight || document.body.scrollHeight
      //页面滚动高度
      const scrollTop =
        document.documentElement.scrollTop || document.body.scrollTop
      //窗口可视范围高度
      var clientHeight =
        window.innerHeight ||
        Math.min(
          document.documentElement.clientHeight,
          document.body.clientHeight
        )
      if (clientHeight + scrollTop >= scrollHeight - offsetY) {
        // 判断是否还有数据
        if (this.result?.hasNext) {
          this.actionGetResult({
            page: this.result.num + 1,
            loadMore: true,
          })
        }
      }
    })
  }
}
